import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import React, { ReactNode, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ChronosLicense, getLicensedGPUs } from "userful-chronos-app-common-js/dist/models/license/license";
import { LicensedGPUContext } from "./LicensedGPUsContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/pro-regular-svg-icons";
import { VideoEngineComp } from "userful-chronos-app-common-js/dist/models/ve/videoEngines";

interface IProps {
    disabled?: boolean;
    children: ReactNode;
    license: ChronosLicense;
    licenseReady: boolean;
    videoEngines: VideoEngineComp[];
    videoEnginesReady: boolean;
    noCheck?: boolean;
}

export default function ({
    children,
    disabled,
    license,
    licenseReady,
    videoEngines,
    videoEnginesReady,
    noCheck,
}: IProps) {
    const { t } = useTranslation();

    const installedGPUs = videoEngines.flatMap((item) => item.gpus);

    const [gpus, setGPUs] = useState(disabled ? installedGPUs : getLicensedGPUs(license, installedGPUs));

    useEffect(() => {
        if (licenseReady && videoEnginesReady) {
            const installedGPUs = videoEngines.flatMap((item) => item.gpus);
            const licensedGPUs = disabled
                ? installedGPUs
                : getLicensedGPUs(
                      license,
                      videoEngines.flatMap((item) => item.gpus),
                  );
            setGPUs(licensedGPUs);
        }
    }, [license, licenseReady, videoEngines, videoEnginesReady]);

    if (!licenseReady || !videoEnginesReady) {
        return (
            <div className={`wrapper-loading`}>
                <div className="loading">
                    <FontAwesomeIcon icon={faCircleNotch} spin />
                </div>
            </div>
        );
    }

    const getErrorText = () => {
        if (disabled) {
            return "";
        }
        if (videoEngines.findIndex((v) => v.activation === "ACTIVE") < 0) {
            return t("Error.noVideoEngines");
        }
        const installedGPUs = videoEngines.flatMap((item) => item.gpus);
        if (installedGPUs.length < 1) {
            return t("Error.noGPUs");
        }
        if (gpus.length < 1) {
            return t("Error.noLicensedGPUs", { gpus: installedGPUs.map((item) => item.gpuData.model).join(", ") });
        }
        return "";
    };

    const icon =
        videoEngines.length < 1 ? (
            <FontAwesomeIcon icon={faCircleNotch} style={{ marginRight: "8px" }} spin />
        ) : (
            <FontAwesomeIcon icon={faCircleExclamation} style={{ color: " #D13E2C", marginRight: "8px" }} />
        );

    const NoLicensedGPUs = () => (
        <div className="noLicensedGPUs">
            {icon}
            {getErrorText()}
        </div>
    );

    const errorText = getErrorText();

    return (
        <LicensedGPUContext.Provider value={{ gpus }}>
            <>{!noCheck && errorText ? <NoLicensedGPUs /> : children}</>
        </LicensedGPUContext.Provider>
    );
}
